<template>
  <el-dialog :title="$t('PAGE_NEXTYEAR_POP_TITLE')"
             visible
             width="60%"
             @close="onCancel">

    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="10px"
             class="demo-ruleForm">
      <el-form-item class="error-right" prop="day">
        {{$t('ROLL_FOREARD_TASK_TEXT1')}}
        <el-select v-model="ruleForm.day">
          <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
        {{$t('ROLL_FOREARD_TASK_TEXT2')}}
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="onCancel"
                 class="wl-grey">{{$t('comment_reSet')}}</el-button>
      <el-button type="primary"
                 @click="onConfirm"
                 class="wl-green">{{$t('COMMON_ADD')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>

    export default {
        data() {
            return {
                ruleForm: {
                    day: ''
                },
                options: [{
                    value: '7',
                    label: '7'
                }, {
                    value: '30',
                    label: '30'
                }]
            }
        },
        computed: {
            rules() {
                const rules = {
                    day: [
                        {required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'change'},
                    ]
                }
                return rules
            }
        },
        methods: {
            onConfirm() {
                this.$refs.ruleForm.validate(validate => {
                    if (validate) {
                        this.onAdd(this.ruleForm)
                    }
                })
            }
        },
        props: {
            onAdd: Function,
            onCancel: Function
        }
    }
</script>
<style scoped>
  .wl-m-select {
    width: 100%;
  }
</style>
